import { Link } from 'react-router-dom';

// Grid of titled cards; items with `to` become links.
export default function LocaleCards({ items, numbered = false, linkLabel }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
      {items.map((item, i) => {
        const inner = (
          <>
            {numbered && <span className="text-xs font-inter font-medium tracking-[0.3em] uppercase text-primary mb-3 block">0{i + 1}</span>}
            <h3 className="font-inter font-bold text-lg text-foreground mb-2">{item.title}</h3>
            <p className="text-sm text-muted-foreground font-inter leading-relaxed">{item.text}</p>
            {item.to && linkLabel && <span className="inline-block mt-4 text-xs font-inter font-semibold tracking-wider uppercase text-primary">{linkLabel} →</span>}
          </>
        );
        const cls = 'block rounded-2xl border border-border/30 bg-card/30 backdrop-blur-sm p-6 transition-colors';
        return item.to ? (
          <Link key={item.title} to={item.to} className={`${cls} hover:border-primary/30`}>{inner}</Link>
        ) : (
          <div key={item.title} className={cls}>{inner}</div>
        );
      })}
    </div>
  );
}